import React from 'react';
import { FormComponentProps } from '../../AccountForm.meta';
import { TabWrapper } from '../../AccountForm.styles';
import { AccountDescription } from '../../components/AccountDescription/AccountDescription';
import { AccountOwnerSelect } from '../../components/AccountOwnerSelect/AccountOwnerSelect';
import { AccountTypeSelect } from '../../components/AccountTypeSelect/AccountTypeSelect';
import { AssetBucketing } from '../../components/AssetBucketing/AssetBucketing';
import { Balance } from '../../components/Balance/Balance';
import { InstitutionNameInput } from '../../components/InstitutionNameInput/InstitutionNameInput';
import { TabsContent } from '../../components/TabsContent/TabsContent';
import { ExcludeFromDebtManagement } from '../../components/ExcludeFromDebtManagement/ExcludeFromDebtManagement';
import { InterestRate } from '../../components/InterestRate/InterestRate';
import { MonthlyContribution } from '../../components/MonthlyContribution/MonthlyContribution';
import { ManagementStyle } from '../../components/ManagementStyle/ManagementStyle';
import { AccountNickname } from '../../components/AccountNickname/AccountNickname';

const Summary = () => {
  return (
    <TabWrapper>
      <AccountTypeSelect />
      <InstitutionNameInput />
      <AccountOwnerSelect />
      <AccountDescription />
      <AccountNickname />
      <Balance label="Balance" />
      <InterestRate label="APR" />
      <MonthlyContribution label="Monthly Payment" />
      <ManagementStyle />
      <AssetBucketing />
      <ExcludeFromDebtManagement />
    </TabWrapper>
  );
};

export const CreditCard = (props: FormComponentProps) => {
  return <TabsContent {...props} tabs={[{ name: 'Summary', Component: Summary }]} />;
};
